import React, {useState} from 'react'

export default function SelectOptions(props) {
    const [selectedOption, setSelectedOption] = useState(props.options[props.options.indexOf(props.selectedOption)]);
    let selectOption = (e) => {
        let id = e.target.id;
        setSelectedOption(id);
        props.selectOption(props.type, id);
    }

    // console.log(props.options.indexOf(props.selectedOption));

    return (
        <div className="selectOption">
            <div  className="title">
                <h4>{props.title}</h4>
            </div>
            <div className={`buttons options ${props.type}`} id={`${props.type}-container`}>
                {
                    props.options.map((item, index )=> {
                        let isSelected = selectedOption === item;
                        return (
                            <button className={`giving_type option`} id={item} onClick={selectOption} key={index}
                                style={isSelected ? {backgroundColor: props.colors.secondary} : {}}>
                                {props.icons ? <i className={props.icons[index]} id={item} 
                                    style={isSelected ? {color: 'white'} : {}}
                                ></i> : null}
                                <h4 id={item} style={isSelected ? {color: 'white', fontWeight: 900} : {}}>{item}</h4>
                            </button>
                        )
                    })
                }
            </div>
        </div>
    )
}
